import Sidebar from "../features/sidebar/components/sidebar"
import HeaderSection from "../components/header-section"

function SimulationHome() {
  return (
    <div className="relative bg-base-white w-full h-[100dvh] flex flex-row items-start justify-start font-text-md-regular">
      <Sidebar />
      <div className="w-full h-[100dvh] flex-1 flex flex-col">
        <HeaderSection />
        <div>SimulationHome</div>
      </div>
    </div>
  )
}

export default SimulationHome
